import { CancellationPolicyResponse } from "../contracts/CancellationPolicyResponse";
import { SetCancellationPolicyRequest } from "../contracts/SetCancellationPolicyRequest";
import { LateCancellationOutcome } from "../enums/LateCancellationOutcome";
import { CancellationPolicy } from "../models/CancellationPolicy";

/** Wire → UI: the fee fields collapse into one `fee` object, null when there is no fee. */
export const toCancellationPolicy = (resp: CancellationPolicyResponse): CancellationPolicy => ({
  cutoffHours: resp.cutoffHours,
  lateOutcome: resp.lateOutcome,
  fee:
    resp.lateOutcome === LateCancellationOutcome.ChargedFee && resp.feePaymentTypeId
      ? {
          paymentTypeId: resp.feePaymentTypeId,
          name: resp.feeName ?? "",
          amountMinorUnits: resp.feeAmountMinorUnits ?? 0,
          currency: resp.currency ?? "",
        }
      : null,
  note: resp.note,
  isBuiltInDefault: resp.isBuiltInDefault,
});

/** UI form values → wire request; a blank note is sent as null. */
export const toSetCancellationPolicyRequest = (values: {
  cutoffHours: number;
  lateOutcome: LateCancellationOutcome;
  feePaymentTypeId: string | null;
  note: string;
}): SetCancellationPolicyRequest => ({
  cutoffHours: values.cutoffHours,
  lateOutcome: values.lateOutcome,
  feePaymentTypeId: values.lateOutcome === LateCancellationOutcome.ChargedFee ? values.feePaymentTypeId : null,
  note: values.note.trim() === "" ? null : values.note.trim(),
});
